module.exports = __webpack_public_path__ + "media/images/wines/airen-24-barricas/bottle-detail-9118183d330c7fa424f4107066c8caeb.png";